import { ILOV } from './lov';

export interface IMembershipCollection {
  edges: IMembershipEdge[];
}

export interface IMembershipEdge {
  node: IMembership;
}

export interface IMembership {
  id: number;
  type: ILOV;
  externalTxnID: string;
  startDate: Date;
  endDate: Date;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  stats: IMembershipStats;
}

export interface IMembershipStats {
  inBalance?: number;
}

export const publicMembershipGQL: Record<string, string> = {};

export const authenticatedMembershipGQL: Record<string, string> = {
  retrieveAllMemberships: `query RetrieveAllMemberships() {
    retrieveAllMemberships: memberships {
      edges {
        node {
          id
          type {
            code
            description
          }
          externalTxnID
          startDate
          endDate
          status
          createdAt
          updatedAt
          stats {
            inBalance
          }
        }
      }
    }
  }`,
  retrieveActiveMembership: `query RetrieveActiveMembership() {
    retrieveActiveMembership: activeMembership {
      node {
        id
        type {
          code
          description
        }
        externalTxnID
        startDate
        endDate
        status
        createdAt
        updatedAt
        stats {
          inBalance
        }
      }
    }
  }`,
};
